<template>
  <div class="model-content">
    <div
      class="model_70"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <div class="img-box">
        <img
          v-if="posterList.lang == 'ug' || !posterList.lang"
          style="width: 100%"
          :src="urlUg"
        />
        <img v-if="posterList.lang == 'zh'" style="width: 100%" :src="urlZh" />
      </div>

      <div class="merchant-name">
        <div class="merchant-name-title">{{ posterList.merchant_name }}</div>
      </div>

      <div class="date">
        <div class="date_text">{{ posterList.date }}</div>
      </div>

      <div class="food_name">
        <div class="food_name_text">{{ posterList.food_name }}</div>
      </div>

      <div class="food_img">
        <img :src="posterList.food_img" alt="" />
      </div>

      <div class="food_price" :style="{ fontSize: posterList.fontSize + 'px' }">
        <span style="font-size: 20px">￥</span>
        <span>{{ posterList.food_price }}</span>
      </div>

      <div class="old_price">
        <div class="old_price_text" v-if="posterList.lang == 'ug'">
          ئەسلى باھاسى :
        </div>
        <div class="old_price_text" v-if="posterList.lang == 'zh'">原价 :</div>
        <div class="line">
          <span class="number"> {{ posterList.old_price }} </span>
          <span v-if="posterList.lang == 'ug'"> يۈەن </span>
          <span v-if="posterList.lang == 'zh'"> 元 </span>
        </div>
      </div>

      <div class="merchant_qrcode">
        <img :src="posterList.merchant_qrcode" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_70",
  data() {
    return {
      posterList: {},
      urlUg: require("../../img/poster/model_70_ug.png"),
      urlZh: require("../../img/poster/model_70_zh.png"),
    };
  },
  created() {
    this.canvasfortitle(
      this.$route.query.merchant_name,
      this.$route.query.food_name,
      this.$route.query
    );
  },
  methods: {
    /**
     * 处理标题和食物名称以生成海报的canvas数据
     *
     * @param merchant_name 商家名称
     * @param food_names 食物名称
     * @param query 查询参数，包括食物价格等
     */
    canvasfortitle(merchant_name = "", food_names = "", query = {}) {
      const MAX_MERCHANT_LENGTH = 40;
      const MAX_FOOD_LENGTH = 36;
      const replaceParentheses = (str = "") => {
        return String(str).replace(/[()（）]/g, (match) =>
          match === "(" || match === "（" ? "-" : " "
        );
      };
      const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length <= maxLength
          ? text
          : `${text.substring(0, maxLength)}...`;
      };
      const res_name = replaceParentheses(merchant_name);
      const food_name = replaceParentheses(food_names);
      this.posterList = {
        ...query,
        merchant_name: truncateText(res_name, MAX_MERCHANT_LENGTH),
        food_name: truncateText(food_name, MAX_FOOD_LENGTH),
        food_price: parseFloat(query.food_price) || 0,
      };
      const priceLength = String(this.posterList.food_price).replace(
        ".",
        ""
      ).length;
      const fontSizeMap = {
        3: 46,
        4: 38,
        5: 30,
        6: 28,
      };
      this.posterList.fontSize = fontSizeMap[priceLength] || 48;
    },
  },
};
</script>

<style scoped>
@import url("../../css/model_62/title.css");
.model-content {
  width: 390px;
  height: 797px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_70 {
  width: 390px;
  height: 797px;
  position: relative;
  overflow: hidden;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.merchant-name {
  position: absolute;
  top: 88px;
  right: 50%;
  transform: translateX(50%);
  color: #ffffff;
  width: 340px;
  height: 56px;
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.merchant-name-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.model_ug .merchant-name-title {
  font-family: "izbolperwaz" !important;
  font-size: 30px;
  line-height: 30px;
}
.model_zh .merchant-name-title {
  font-family: "FZCQK--GBK1-0" !important;
  font-size: 28px;
  line-height: 36px;
}

.date {
  position: absolute;
  top: 160px;
  right: 50%;
  transform: translateX(50%);
  color: #403c3c;
  background-color: #fff;
  border-radius: 30px;
  width: max-content;
  padding: 0px 15px;
  direction: ltr;
  height: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.food_name {
  position: absolute;
  width: 250px;
  height: 70px;
  top: 226px;
  left: 30px;
  color: #fcff00;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-weight: bold;
  text-align: center;
  transform: rotate(4deg);
}

.food_name_text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.model_ug .food_name_text {
  font-family: "izbolperwaz" !important;
  font-size: 30px;
  line-height: 36px;
}
.model_zh .food_name_text {
  font-family: "FZCQK--GBK1-0" !important;
  font-size: 30px;
  line-height: 36px;
}

.food_img {
  position: absolute;
  top: 305px;
  left: -4px;
  width: 336px;
  height: 206px;
  border-radius: 50%;
  overflow: hidden;
  transform: rotate(10deg);
}

.food_img img {
  width: 100%;
  height: 100%;
  clip-path: ellipse(50% 50% at 50% 50%);
  object-fit: cover;
}

.food_price {
  position: absolute;
  bottom: 220px;
  left: 24px;
  width: 130px;
  color: #fff;
  text-align: center;
  line-height: 38px;
  font-weight: bold;
}

.old_price {
  position: absolute;
  bottom: 192px;
  font-size: 12px;
  color: #b84d08;
  display: flex;
  align-items: center;
}

.old_price .line {
  text-decoration: line-through;
  padding-inline: 4px;
}

.model_ug .old_price {
  left: 42px;
}
.model_zh .old_price {
  left: 56px;
}
.merchant_qrcode {
  position: absolute;
  bottom: 13px;
  left: 22px;
  width: 105px;
  height: 105px;
  border-radius: 50%;
  overflow: hidden;
}
.merchant_qrcode img {
  width: 100%;
  height: 100%;
}
.number {
  font-family: "UzluqEgme" !important;
}
</style>
